<template>
  <b-card :class="classCard" class="tm-card" :data-id="cardKey" :id="cardId">
    <div class="justify-content-center text-center">
      <b-row class="justify-content-center">
        <b-col cols="11">
          <b-card-img
            :src="require('../assets/img/'+srcImg)"
            alt="Equipo"
            class="rounded-0"
            @click="something(cardKey)"
          ></b-card-img>
        </b-col>
        <b-col cols="12">
          <div class="tm-person-name" @click="something(cardKey)">
            <span>{{ cName }}</span>
          </div>
        </b-col>
        <b-col cols="12" style="margin-top: 32px;">
          <span class="tm-person-area" id="area-1" style="white-space: pre;">
            {{ cArea }}
          </span>
        </b-col>
        <b-col cols="12">
          <div v-show="cardKey==5 || cardKey==6 || cardKey==7 || cardKey==8" style="margin-top: 27px;"></div>
          <div v-show="cardKey==1"><social-media-icons :icon-key="cardKey" icon-id="icons" :icon-class="classIcons" :icon-media="cMedia"></social-media-icons></div>
          <div v-show="cardKey==2"><social-media-icons :icon-key="cardKey" icon-id="icons2" :icon-class="classIcons" :icon-media="cMedia"></social-media-icons></div>
          <div v-show="cardKey==3"><social-media-icons :icon-key="cardKey" icon-id="icons3" :icon-class="classIcons" :icon-media="cMedia"></social-media-icons></div>
          <div v-show="cardKey==4"><social-media-icons :icon-key="cardKey" icon-id="icons4" :icon-class="classIcons" :icon-media="cMedia"></social-media-icons></div>
          <div v-show="cardKey==5"><social-media-icons :icon-key="cardKey" icon-id="icons" :icon-class="classIcons" :icon-media="cMedia"></social-media-icons></div>
          <div v-show="cardKey==6"><social-media-icons :icon-key="cardKey" icon-id="icons2" :icon-class="classIcons" :icon-media="cMedia"></social-media-icons></div>
          <div v-show="cardKey==7"><social-media-icons :icon-key="cardKey" icon-id="icons3" :icon-class="classIcons" :icon-media="cMedia"></social-media-icons></div>
          <div v-show="cardKey==8"><social-media-icons :icon-key="cardKey" icon-id="icons4" :icon-class="classIcons" :icon-media="cMedia"></social-media-icons></div>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import SocialMediaIcons from './socialMediaIcons'

export default {
  components: {
    SocialMediaIcons
  },
  props: {
    cardId: {
      type: String
    },
    cardKey: {
      type: Number
    },
		srcImg: {
			type: String
		},
		cName: {
      type: String
		},
		cArea: {
      type: String
    },
    cMedia: {
      type: String
    },
    classIcons: {
      type: String
		},
    classCard: {
      type: String
    }
  },
  methods:{
    something(data){
      this.$emit('event',data)
    }
  }
}
</script>